// extracted by mini-css-extract-plugin
export default {"login-screen":"LoginScreen_login-screen__Klc6N","login-form":"LoginScreen_login-form__UOrli","error-msg-p":"LoginScreen_error-msg-p__2jhl7"};